import { render, staticRenderFns } from "./ProjectPhotos.vue?vue&type=template&id=1de3ccc4&"
import script from "./ProjectPhotos.vue?vue&type=script&lang=js&"
export * from "./ProjectPhotos.vue?vue&type=script&lang=js&"
import style0 from "./ProjectPhotos.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports